import React from "react";
import { Helmet } from 'react-helmet-async';
import '../../../assets/styles/Planning.css'
import planningHero from "../../../assets/images/Project Planning.png";
import planningProcess from "../../../assets/images/Project Planning.png";

const ConstructionPlanningPage = () => {
  return (
    <>
      <Helmet>
        {/* <!-- Primary Meta Tags for SEO --> */}
        <title> Planning & Architecture – BuddyTech Solutions </title>
        <meta name="description" content="Structural planning and architectural layout services with AutoCAD and Revit." />
        <meta name="keywords" content="construction planning, architecture" />

        {/* <!-- Open Graph / Facebook Meta Tags --> */}
        <meta property="og:title" content="Planning & Architecture – BuddyTech Solutions" />
        <meta property="og:description" content="Structural planning and architectural layout services with AutoCAD and Revit." />
        <meta property="og:keywords" content="construction planning, architecture" />
        <meta property="og:image" content="https://buddytechsolutions.in/assets/images/thumbnailimages.jpg" />
        <meta property="og:url" content="https://buddytechsolutions.in/services/constructions/planning" />
        <meta property="og:type" content="website" />

        {/* <!-- Optional: Facebook App ID --> */}
        {/* <!-- <meta property="fb:app_id" content="your_facebook_app_id" /> --> */}

        {/* <!-- Twitter Meta Tags --> */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Planning & Architecture – BuddyTech Solutions" />
        <meta name="twitter:description" content="Structural planning and architectural layout services with AutoCAD and Revit." />
        <meta name="twitter:keywords" content="construction planning, architecture" />
        <meta name="twitter:image" content="https://buddytechsolutions.in/assets/images/thumbnailimages.jpg" />
      </Helmet>
      <div className="planning-container">
        <header className="planning-hero">
          <div className="planning-hero-content">
            <h1>Construction Planning</h1>
            <p>
              We provide strategic planning services to ensure your construction project is delivered on time, within budget, and with precision.
            </p>
          </div>
          <img src={planningHero} alt="Construction Planning Hero" className="planning-hero-img" />
        </header>

        <section className="planning-section">
          <div className="planning-text">
            <h2>Our Planning Solutions</h2>
            <p>
              Our comprehensive planning services cover every phase of the project lifecycle, from concept development to project delivery, helping clients minimize risk and optimize resources.
            </p>
            <ul>
              <li>Feasibility & Site Analysis</li>
              <li>Resource & Material Scheduling</li>
              <li>Gantt Charts & Milestone Tracking</li>
              <li>Project Budget Forecasting</li>
              <li>Risk & Safety Planning</li>
            </ul>
          </div>
          <img src={planningProcess} alt="Planning Process" className="planning-img" />
        </section>

        <section className="planning-tools">
          <h2>Tools We Use</h2>
          <div className="tools-grid">
            <span>AutoCAD</span>
            <span>Primavera P6</span>
            <span>MS Project</span>
            <span>SketchUp</span>
            <span>Excel & Google Sheets</span>
            <span>Navisworks</span>
            <span>Bluebeam</span>
            <span>SmartDraw</span>
          </div>
        </section>
        <section className="contact-options">
          <div className="contact-card email">
            <h2>📧 Email</h2>
            <p>Send us an email for inquiries, support or collaboration opportunities.</p>
            <a href="mailto:vinujaya.v7@gmail.com" target="_blank" rel="noopener noreferrer">
              Send Email
            </a>
          </div>

          <div className="contact-card whatsapp">
            <h2>💬 WhatsApp</h2>
            <p>Start a chat with us on WhatsApp for quick responses and updates.</p>
            <a href="https://wa.me/917010658911" target="_blank" rel="noopener noreferrer">
              Chat on WhatsApp
            </a>
          </div>

          <div className="contact-card phone">
            <h2>📞 Call Us</h2>
            <p>Prefer to talk directly? Give us a call anytime during business hours.</p>
            <a href="tel:+917010658911">Call Us</a>
          </div>
        </section>
      </div>
    </>
  );
};

export default ConstructionPlanningPage;